import { defineAsyncComponent, h } from 'vue'
import * as config from '@/dashboards'
import { useShellStore } from '@/store'
import { piniaStoreModules } from 'frontendcommon-3'
import { getActivePinia, mapState } from 'pinia'
export default defineAsyncComponent(() => {
  const commonStore = piniaStoreModules.useCommon(getActivePinia())
  return new Promise((resolve) => {
    const commonState = commonStore.$state

    const mount = () => {
      window.removeEventListener('imgfinder:loaded', mount)
      resolve({
        setup: () => () => h('div', { id: 'farmapremium-imgfinder' }),
        mounted () {
          const tokens = {
            farmapremium: this.tokens.farmapremium
          }
          window.ImageFinderModal.mount('#farmapremium-imgfinder', commonState, tokens, config)
        },
        computed: {
          ...mapState(useShellStore, ['tokens'])
        }
      })
    }
    if (window.ImageFinderModal) mount()
    else window.addEventListener('imgfinder:loaded', mount)
  })
})
